export default "__VITE_ASSET__8269579d__"